import { Component } from '@angular/core';

@Component({
    selector: 'app-lms-enrolled-created',
    templateUrl: './lms-enrolled-created.component.html',
    styleUrls: ['./lms-enrolled-created.component.scss']
})
export class LmsEnrolledCreatedComponent {}